<template>
  <section class="l-content clean-statistic-page">
    <!-- 查询区域 -->
    <el-card class="filter-card" shadow="hover">
      <el-form :inline="true" :model="condition" class="filter-form">
        <el-form-item label="日期范围" label-width="80px">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width: 280px;"
            size="medium"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="loadData" icon="el-icon-search" size="medium">
            查询
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-divider class="divider-line"></el-divider>

    <!-- 顶部统计卡片 -->
    <el-row :gutter="20" v-if="stats" class="stats-row">
      <el-col :span="6">
        <el-card class="stat-card" shadow="hover">
          <div class="stat-card-inner">
            <div class="stat-icon-wrapper">
              <i class="el-icon-s-data stat-icon"></i>
            </div>
            <div class="stat-content">
              <div class="stat-title">总任务数</div>
              <div class="stat-value">{{ stats.totalTasks }}</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="stat-card" shadow="hover">
          <div class="stat-card-inner">
            <div class="stat-icon-wrapper completed">
              <i class="el-icon-circle-check stat-icon"></i>
            </div>
            <div class="stat-content">
              <div class="stat-title">已完成</div>
              <div class="stat-value">{{ stats.completedTasks }}</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="stat-card" shadow="hover">
          <div class="stat-card-inner">
            <div class="stat-icon-wrapper passed">
              <i class="el-icon-success stat-icon"></i>
            </div>
            <div class="stat-content">
              <div class="stat-title">合格数</div>
              <div class="stat-value">{{ stats.passedTasks }}</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="stat-card" shadow="hover">
          <div class="stat-card-inner">
            <div class="stat-icon-wrapper rate">
              <i class="el-icon-pie-chart stat-icon"></i>
            </div>
            <div class="stat-content">
              <div class="stat-title">合格率</div>
              <div class="stat-value">{{ stats.passRate }}<span class="unit">%</span></div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 工人统计 & 地点统计 同一行 -->
    <el-row v-if="stats" :gutter="20" class="tables-row">
      <!-- 工人统计 -->
      <el-col :span="12">
        <div class="section-wrapper">
          <el-divider class="section-divider">
            <span class="section-title">按工人统计</span>
          </el-divider>
          <el-card class="table-card" shadow="hover">
            <el-table :data="stats.byWorker" border stripe class="custom-table">
              <el-table-column type="index" label="序号" width="60" align="center" />
              <el-table-column prop="workerName" label="工人姓名"  align="center" />
              <el-table-column prop="total" label="总任务数" width="120" align="center" />
              <el-table-column prop="passed" label="合格数" width="120" align="center" />
              <el-table-column prop="avgScore" label="平均打分" width="120" align="center">
                <template slot-scope="scope">
                  <span class="score-text">
                    {{ scope.row.avgScore ? scope.row.avgScore.toFixed(1) : '-' }}
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </el-card>
        </div>
      </el-col>
      <!-- 地点统计 -->
      <el-col :span="12">
        <div class="section-wrapper">
          <el-divider class="section-divider">
            <span class="section-title">按地点统计</span>
          </el-divider>
          <el-card class="table-card" shadow="hover">
            <el-table :data="stats.byLocation" border stripe class="custom-table">
              <el-table-column type="index" label="序号" width="60" align="center" />
              <el-table-column prop="locationName" label="地点名称"  align="center" />
              <el-table-column prop="total" label="总任务数" width="120" align="center" />
              <el-table-column prop="passed" label="合格数" width="120" align="center" />
              <el-table-column prop="avgScore" label="平均打分" width="120" align="center">
                <template slot-scope="scope">
                  <span class="score-text">
                    {{ scope.row.avgScore ? scope.row.avgScore.toFixed(1) : '-' }}
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </el-card>
        </div>
      </el-col>
    </el-row>
  </section>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'CleanStatistic',
  computed: {
    ...mapState(['userInfo'])
  },
  data() {
    const today = new Date()
    const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1)
    const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0)
    return {
      dateRange: [startOfMonth, endOfMonth],
      condition: {},
      stats: null
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      if (!this.dateRange || this.dateRange.length !== 2) {
        this.$lgh.notifyWarning('请选择日期范围')
        return
      }
      const startDate = this.dateRange[0].toISOString().split('T')[0]
      const endDate = this.dateRange[1].toISOString().split('T')[0]
      this.stats = await this.$lgh.get('api/clean/statistic/range', {
        enterpriseCode: this.userInfo.enterpriseCode,
        startDate: startDate,
        endDate: endDate
      })
    }
  }
}
</script>

<style lang="less" scoped>
.clean-statistic-page {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: 100%;
}

.filter-card {
  border-radius: 8px;
  .filter-form {
    display: flex;
    align-items: center;
    gap: 10px;
  }
}

.divider-line {
  margin: 20px 0;
}
.el-divider__text{
  padding: 0px!important;
}
.stats-row {
  margin-bottom: 20px;

}

.stat-card {
  border-radius: 10px;
  border: none;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff;
  overflow: hidden;
  transition: all 0.3s ease;
    height: 100px;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 20px rgba(102, 126, 234, 0.3);
  }

  .stat-card-inner {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  .stat-icon-wrapper {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;

    &.completed {
      background: rgba(103, 194, 58, 0.3);
    }
    &.passed {
      background: rgba(245, 108, 108, 0.3);
    }
    &.rate {
      background: rgba(230, 166, 0, 0.3);
    }

    .stat-icon {
      font-size: 24px;
      color: #fff;
    }
  }

  .stat-content {
    .stat-title {
      font-size: 14px;
      opacity: 0.9;
      margin-bottom: 4px;
    }
    .stat-value {
      font-size: 26px;
      font-weight: 600;
      .unit {
        font-size: 16px;
        margin-left: 2px;
      }
    }
  }
}

.section-wrapper {
  margin-bottom: 20px;

  .section-divider {
    margin: 20px 0;
    padding: 0;
    .section-title {
      font-size: 16px;
      font-weight: 600;
      color: #303133;
      padding: 0 12px;
      background-color: #f5f7fa;
    }
  }

  .table-card {
    border-radius: 8px;
    border: none;

    .custom-table {
      width: 100%;
      .el-table__header {
        background-color: #f0f2f5;
        th {
          background-color: #f0f2f5;
          color: #606266;
          font-weight: 500;
        }
      }
      .el-table__row {
        &:hover {
          background-color: #ecf5ff;
        }
      }
      .score-text {
        color: #409eff;
        font-weight: 500;
      }
    }
  }
}
</style>
